export enum VrsChatStatus {
  Connected = 'connected',
  Connecting = 'connecting',
  Disconnected = 'disconnected',
  FailedToConnect = 'failedToConnect',
}
